import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const companyMessages = defineMessages({
  required: {
    id: 'bookingClasses.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const nameMessages = defineMessages({
  required: {
    id: 'bookingClasses.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'bookingClasses.form.name.max',
    defaultMessage: 'The name should be one letter'
  }
})

const priorityMessages = defineMessages({
  required: {
    id: 'bookingClasses.form.priority.required',
    defaultMessage: 'The priority is required'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(companyMessages.required))
    }),
    name: yup.string().required(intl.formatMessage(nameMessages.required)).max(1, intl.formatMessage(nameMessages.max)),
    priority: yup.string().required(intl.formatMessage(priorityMessages.required))
  })
}
